
import { Component, Inject, OnInit, ViewChild, ChangeDetectorRef, AfterViewInit, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../core/auth.service';

import { PatientsService } from '../../patients/patients.service';
import { PatientService } from '../patient.service';

@Component({
    selector: 'app-patient-menu-action',
    templateUrl: 'patient-menu-action.component.html',
    styleUrls: ['patient-menu-action.component.scss']
})

export class PatientMenuActionComponent {

    @Input() isProfile: boolean = false;
    @Input() patient ;
    @Input() status ;
    @Input() type ;
    @Input() userRoleId ;
    @Input() appService ;
    @Input() isDefaultClinic ;

    @Output() exportMap = new EventEmitter();

    @Output() openSEModal = new EventEmitter();

    @Output() openContactPatientModal = new EventEmitter();

    @Output() openDI = new EventEmitter();

    @Output() openSendReminder = new EventEmitter();

    @Output() openEditModal = new EventEmitter();

    @Output() openReactiveModal = new EventEmitter();

    @Output() openModal = new EventEmitter();

    @Output() coordinateSendEmail = new EventEmitter();

    @Output() assigntToPool = new EventEmitter();

    @Output() requestAccess = new EventEmitter();

    @Output() generateToken = new EventEmitter();

    constructor(
        public authService: AuthService,
        public router: Router,
        public patientsService: PatientsService,
        public patientService: PatientService,
    ) {

    }

    showSendReminderBtn(patient) {
        let action = patient.latest_action.template;

        if (this.patientsService.isOverdue(action)) {
            return true;
        }

        return false;
    }

    showExportMapBtn(patient) {
        if (this.userRoleId === this.authService.ROLES.ASSISTANT || this.userRoleId === this.authService.ROLES.ASSISTANT_PLUS) {
            return false;
        }

        let action = patient.latest_action.template;

        if (this.patientsService.isNewMapAvailable(action)
            || this.patientsService.isDIFinished(action)
            || this.patientsService.isSEFinished(action)
            || this.patientsService.isRenew(action)
        ) {
            return true;
        }

        return false;
    }

    showOpenSeBtn(patient) {
        let action = patient.latest_action.template;

        if (this.patientsService.isNewMapAvailable(action)
            || this.patientsService.isSEFinished(action)
            || this.patientsService.isDiOpened(action)
        ) {
            return false;
        }

        return true;
    }

    showOpenSeBtnForCoordinator(patient) {
        if ((!patient.download_files || patient.download_files.length === 0) && !this.patientsService.isNewMapAvailable(patient.latest_action.template)) {
            return true;
        }
        return false;
    }

    showOpenDiBtn(patient) {
        if (this.userRoleId === this.authService.ROLES.ASSISTANT || this.userRoleId === this.authService.ROLES.ASSISTANT_PLUS) {
            return false;
        }

        let action = patient.latest_action.template;

        if (this.patientsService.isNewMapAvailable(action)
            || this.patientsService.isSEFinished(action)
            || this.patientsService.isDiOpened(action)
        ) {
            return true;
        }

        return false;
    }

    edit(id) {
        if (this.isProfile) {
            return this.openEditModal.emit();
        }
        return this.router.navigate(['patients/edit/' + id], { queryParams: { modalTitle: 'Update Patient', status: 'Activated' } } );
    }

    assign(id) {
        this.router.navigate(['patients/assign/' + id]);
    }

    marked(id) {
        this.router.navigate(['patients/marked/' + id]);
    }

    reactivate(id) {
        this.openReactiveModal.emit({'id' : id });
    }

    doAction(action) {
        const data = {
            id: this.patient.id,
            action: action,
            questionnaire: this.patient.questionnaires_for_filter ? this.patientsService.getLastestDI(this.patient.questionnaires_for_filter) : null
        };
        switch (action) {
            case 'export_map':
                let type = 'DI';
                if (data.questionnaire && data.questionnaire.step < this.patientsService.MAP_EXISTS) {
                    data.questionnaire = this.patientsService.getLastestSE(this.patient.questionnaires_for_filter);
                    type = 'SE';
                }

                data['type'] = type;
                return this.exportMap.emit(data);
            case 'open_send_reminder':
                return this.openSEModal.emit(data);
            case 'open_se':
                return this.openSEModal.emit(data);
            case 'open_di':
                return this.openDI.emit();

            case 'coordinate_send_email':
                return this.coordinateSendEmail.emit();

            case 'open_contact_patient':
                return this.openContactPatientModal.emit(data);

            case 'assign_to_pool':
                return this.assigntToPool.emit();

            case 'request_access':
                return this.requestAccess.emit();

            case 'generate_token':
                return this.generateToken.emit();

            default:
                return false;
        }
    }

    openConfirm(params) {
        return this.openModal.emit(params);
    }

    getPermissionStatus(stt){
        return Object.keys(this.patientService.ACCESSSTATUS).find((status) => {
            return this.patientService.ACCESSSTATUS[status] === stt ;
        })
    }
}
